import React from 'react';

import { Card, CardBody } from 'reactstrap';
import { Icon, PanelHeader, HeroBadge, IconStack } from 'js/components';
import { faLocationPinLock } from '@fortawesome/pro-light-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

const FullPageMessage = ({ message, icon }) => {
  return (
    <div>
      <PanelHeader size="xs" />
      <div className="content">
        <Card className="mt-5">
          <CardBody>
            <HeroBadge
              renderIcon={() =>
                icon ? (
                  icon
                ) : (
                  <div className="text-secondary">
                    <IconStack className="complete-icon">
                      <Icon icon={faCircle} />
                      <Icon icon={faLocationPinLock} inverse transform="shrink-6" />
                    </IconStack>
                  </div>
                )
              }
            >
              {typeof message === 'string' ? <p>{message}</p> : message}
            </HeroBadge>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default FullPageMessage;
